import { render, staticRenderFns } from "./RequisitionCommentListItem.vue?vue&type=template&id=a0fdb08a&"
import script from "./RequisitionCommentListItem.vue?vue&type=script&lang=ts&"
export * from "./RequisitionCommentListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports